console.log('footer.js jQuery status is', window.$);


(function () {
    const select = document.querySelector('[data-investor-type-subscribe]');

    if (select) {
        const hasSelect = () => {
            if (select.value === '') {
                select.classList.add('gray');
            } else {
                select.classList.remove('gray');
            }
        }

        hasSelect();

        select.addEventListener('change', () => {
            hasSelect();
        })
    }

    $('a[href="#entry"]').click(function () {
        console.log('bingo');
        let target = $(this).attr('href');
        // $(target).removeClass('d-none');

        $('#entryModal').modal('toggle');
        $('#entry [name="sitelang"]').val($.cookie('sitelang'));
        translateEntry($.cookie('sitelang'));
        $(this).attr('id') == "swapInvestor" ? openInvestor() : openCountry();
    });
}());

